module.exports = __webpack_public_path__ + "static/img/thumbnail_nofile_announcement.949b902c.svg";